//#region Imports
import { Fragment, Component } from 'react';
import I18n from 'I18n';
import { connect } from 'react-redux';
import get from 'transmute/get';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import LegalConsentInputs from 'MeetingsLib/components/input/LegalConsentInputs';
import { getStagedLegalConsentResponses } from 'MeetingsLib/selectors/LegalConsentFormSelectors';
import { getCustomParams, getOffline as getOfflineSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import { HiddenAriaStatus } from 'MeetingsLib/components/decorative/HiddenAriaStatus';
import { View } from 'foundations-components/components/View';
//#endregion Imports
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class LegalConsentForm extends Component {
  constructor(...args) {
    super(...args);
    this.renderAccessibleMessage = () => {
      const {
        branding: {
          companyName
        },
        dateTime,
        userTimezone
      } = this.props;
      const selectedDate = I18n.moment(dateTime).tz(userTimezone).format('LLLL');
      let accessibleMessage = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "accessible.privacyStatusNoCompany",
        options: {
          selectedDate
        }
      });
      if (companyName) {
        accessibleMessage = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "accessible.privacyStatus",
          options: {
            domain: companyName,
            selectedDate
          }
        });
      }
      return accessibleMessage;
    };
    this.renderHeader = () => {
      return /*#__PURE__*/_jsx("div", {
        style: {
          position: 'relative'
        },
        children: /*#__PURE__*/_jsxs(H4, {
          tabIndex: 1,
          paddingInline: "800",
          paddingBlockStart: "400",
          marginBlockEnd: "500",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "dataPrivacy"
          }), /*#__PURE__*/_jsx(HiddenAriaStatus, {
            role: "status",
            "aria-live": "polite",
            children: this.renderAccessibleMessage()
          })]
        })
      });
    };
    this.renderLegalConsentInputs = () => {
      const {
        compact,
        legalConsentOptions,
        stagedLegalConsentResponses,
        setGivenConsent
      } = this.props;
      return /*#__PURE__*/_jsx(View, {
        marginInline: "800",
        marginBlockEnd: compact ? '400' : '0',
        minBlockSize: compact ? 'auto' : '180px',
        maxBlockSize: compact ? 'auto' : '80%',
        flexShrink: compact ? 'auto' : 1,
        overflowY: compact ? 'visible' : 'scroll',
        overflowX: compact ? 'visible' : 'hidden',
        children: /*#__PURE__*/_jsx(LegalConsentInputs, {
          legalConsentResponses: stagedLegalConsentResponses,
          legalConsentOptions: legalConsentOptions,
          setGivenConsent: setGivenConsent
        })
      });
    };
  }
  componentDidMount() {
    this.props.legalConsentFormShown();
  }
  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderHeader(), this.renderLegalConsentInputs()]
    });
  }
}
export default connect(state => ({
  legalConsentOptions: get('legalConsentOptions', getCustomParams(state)),
  stagedLegalConsentResponses: getStagedLegalConsentResponses(state),
  offline: getOfflineSelector(state),
  userTimezone: state.userTimezone
}), Object.assign({}, FormActions))(LegalConsentForm);